import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import { TakeTypeEnum, DeliveryMethod as DeliveryMethodEnum, DayTypeEnum } from '../type';

interface CopyRouteParams {
  distributionUnitId: number;
  timeIntervalId: number;
  dayType: DayTypeEnum;
  targetTimeIntervals: number[];
  deliveryMethod: number;
}
// 获取复制线路弹窗中的餐段信息
export const getMealTimesWithDayType = async (params: {
  distributionUnitId: string;
  deliveryMethod: DeliveryMethodEnum;
}) => {
  const data = await fetch(
    '/saasmerchant/fsarea/distribution/unit/dispatchroute/holidayRoute/times',
    {
      type: 'POST',
      params,
      useJson: true,
    },
  );
  return data;
};
// 复制线路
export const copyRoute = async (params: CopyRouteParams) => {
  const data = await fetch('/saasmerchant/fsarea/distribution/unit/dispatchroute/routecopy', {
    type: 'POST',
    useJson: true,
    params,
  });

  return data;
};

export interface BindUserInfoVOS {
  employeeId?: number;
  employeeName?: string;
  transferStationId: number;
  transferStationName: number;
}
interface LockRouteParams {
  distributionUnitId: number;
  dispatchRouteId: number;
  bindUserInfoVOS: Array<BindUserInfoVOS>;
}
export const lockRoute = async (params: LockRouteParams) => {
  const data = await fetch('/saasmerchant/fsarea/distribution/unit/dispatchroute/binduser', {
    type: 'POST',
    useJson: true,
    params,
  });
  return data;
};
export const getEmployeeList = async (distributionUnitId: number) => {
  const data = await fetch('/saasmerchant/fsarea/employee/search-sender', {
    type: 'GET',
    params: {
      distributionUnitId,
    },
  });
  return data;
};
export const getRouteDetail = async (dispatchRouteId) => {
  const data = await fetch('/saasmerchant/fsarea/distribution/unit/dispatchroute/searchUser', {
    type: 'GET',
    params: {
      dispatchRouteId,
    },
  });
  return data;
};
interface GetCompanyListParams {
  distributionUnitId: number;
  addressType?: number;
  companyName?: string;
  address?: string;
  timeIntervalId: number;
  deliveryMethod: number;
}
// 获取商圈下的企业
export const getCompanyList = async (params: GetCompanyListParams) => {
  const data = await fetch<{ companyId: number; companyName: string }[]>(
    '/saasmerchant/fsarea/distribution/unit/dispatchroute/getCompanyLists',
    {
      type: 'POST',
      useJson: true,
      params: filterNull(params),
    },
  );
  return data;
};

interface GetAddressListParams {
  distributionUnitId: number;
  companyId: number;
  deliveryMethod: number;
  timeIntervalId: number;
}
// 查询取餐点
export const getAddressList = async (params: GetAddressListParams) => {
  const data = await fetch<{ companyAddressId: string; adderss: string }[]>(
    '/saasmerchant/fsarea/distribution/unit/dispatchroute/transitaddrlist',
    {
      type: 'GET',
      params,
    },
  );
  return data;
};

// 获取无线路取餐点弹窗中的企业地址list
export const getHomelessCompanyAddressList = async (params: {
  distributionUnitId: string;
  timeIntervalId: string;
  dayType: DayTypeEnum;
  deliveryMethod: DeliveryMethodEnum;
  addressType?: TakeTypeEnum;
  companyName?: string;
  address?: string;
}) => {
  const data = await fetch(
    '/saasmerchant/fsarea/distribution/unit/dispatchroute/homeless/companyLists',
    {
      type: 'GET',
      params,
    },
  );
  return (data || []).map((item) => ({
    value: item.companyId,
    label: item.companyName,
    key: item.companyId,
    children: item.addrs?.map((address) => ({
      value: address.addrId,
      key: address.addrId,
      label: address.address,
    })),
  }));
};
// 保存无线路取餐点
export const saveHomelessRoute = async (params) => {
  const data = await fetch('/saasmerchant/fsarea/distribution/unit/dispatchroute/homeless', {
    type: 'POST',
    params,
    useJson: true,
  });
  return data;
};

// 获取线路list
export const getAllRouteList = async (params: {
  timeIntervalId: string;
  distributionUnitId: string;
  deliveryMethod: DeliveryMethodEnum;
  dayType: DayTypeEnum;
}) => {
  const data = await fetch('/saasmerchant/fsarea/distribution/unit/dispatchroute/simple/list', {
    type: 'POST',
    params,
    useJson: true,
  });
  return data;
};
// 设置区分工作日、节假日标记
export const saveHolidayFlag = async (params) => {
  const data = await fetch(
    '/saasmerchant/fsarea/distribution/unit/dispatchroute/add/holidayRoute',
    {
      type: 'POST',
      params,

      useJson: true,
    },
  );
  return data;
};

// 获取区分工作日、节假日标记
export const getHolidayFlag = async (params) => {
  const data = await fetch('/saasmerchant/fsarea/distribution/unit/dispatchroute/holidayRoute', {
    type: 'GET',
    params,
  });
  return data;
};
// 节假日线路是否关联配置数据   如果已配置，删除时需要弹窗二次确定
export const checkHolidayConfig = async (params: {
  distributionUnitId: string;
  timeIntervalId: string;
  deliveryMethod: DeliveryMethodEnum;
}) => {
  const data = await fetch(
    '/saasmerchant/fsarea/distribution/unit/dispatchroute/check/holidayConf',
    {
      type: 'POST',
      params,
      useJson: true,
    },
  );
  return data;
};

// 手动创建线路
export const createDispatchRoute = async (params) => {
  // dispatchRouteName	string
  // dispatchRouteSimpleName	string
  // deliveryMethod	number
  // 配送方式 0-直送 1-中转
  // timeIntervalId	number
  // addressIds	number []
  // dayType	integer
  // 1:工作日2:节假日
  // distributionUnitId
  const data = await fetch('/saasmerchant/fsarea/distribution/unit/dispatchroute/add', {
    type: 'POST',
    params,
    useJson: true,
  });
  return data;
};

// 删除线路
export const deleteDispatchRoute = async (dispatchRouteId) => {
  const data = await fetch('/saasmerchant/fsarea/distribution/unit/dispatchroute/delete', {
    type: 'GET',
    params: { dispatchRouteId },
  });
  return data;
};

// 获取调整线路弹窗中的企业地址
export const getCompanyAddressList = async (params: {
  dispatchRouteId: string;
  companyName?: string;
  addressType?: TakeTypeEnum;
  address?: string;
}) => {
  const data = await fetch('/saasmerchant/fsarea/distribution/unit/dispatchroute/search', {
    type: 'POST',
    params,
    useJson: true,
  });
  return (data || []).map((company) => ({
    title: company.companyName,
    value: company.companyId,
    key: company.companyId,
    children: company.addrs.map((addr) => ({
      title: addr.address,
      value: addr.addrId,
      key: addr.addrId,
    })),
  }));
};

// 调整线路
export const modifyDispatchRoute = async (params) => {
  const data = await fetch('/saasmerchant/fsarea/distribution/unit/dispatchroute/modify', {
    type: 'POST',
    params,
    useJson: true,
  });
  return data;
};

export const DeliveryMethod = {
  Direct: {
    value: 0,
    name: '直送',
  },
  Transit: {
    value: 1,
    name: '中转',
  },
};

export const DeliveryMethodList = [
  {
    label: '直送',
    value: 0,
  },
  {
    label: '中转',
    value: 1,
  },
];
// 框选地图获取企业
export const mapGetCompany = async (params) => {
  const data = await fetch('/saasmerchant/fsarea/dispatchroute/company/map/get', {
    type: 'POST',
    useJson: true,
    params,
  });
  return data;
};

// 框选地图获取当前配送单元的企业
export const mapGetCompanyByDeliveryUnit = async (params: any) => {
  const data = await fetch('/saasmerchant/fsarea/distribution/unit/dispatchroute/company/map/get', {
    type: 'POST',
    useJson: true,
    params,
  });
  return data;
};

// 框选地图获取企业
export const mapCbdLngLat = async (params) => {
  const data = await fetch('/saasmerchant/fsarea/dispatchroute/cbd-location', {
    params,
  });
  return data;
};

export const mapUnitLngLat = async (params: any) => {
  const data = await fetch('/saasmerchant/fsarea/distribution/unit/dispatchroute/cbdLocations', {
    params,
  });

  return data || [];
};

export const formatLngLatToArr = (arr) => {
  const result: any = [];
  arr.forEach((item: any) => {
    result.push([item?.lng, item?.lat]);
  });
  return result;
};
